import { useQuizHistory } from "./useQuizHistory"

export const useQuizIdFromUrl = () => {
  const {
    params: { quiz },
  } = useQuizHistory()

  return quiz
}
